import * as React from "react";
const SvgFiRrCloudDrizzle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-drizzle_svg__a)">
      <path
        fill="#062147"
        d="M18 24a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1m-6 0a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1m-6 0a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1m-1-4.027q-.056 0-.11-.006A5.527 5.527 0 0 1 1.8 10.43a1 1 0 0 0 .345-.9 8.2 8.2 0 0 1-.033-2.89A7.95 7.95 0 0 1 8.5.138a8.06 8.06 0 0 1 8.735 4.44 1.04 1.04 0 0 0 .742.569A7.5 7.5 0 0 1 19.4 19.39a1 1 0 1 1-.792-1.837 5.5 5.5 0 0 0-1.025-10.447 3.01 3.01 0 0 1-2.158-1.672A6 6 0 0 0 4.086 6.967a6.1 6.1 0 0 0 .024 2.18 3 3 0 0 1-.964 2.763 3.522 3.522 0 0 0 1.964 6.069A1 1 0 0 1 5 19.973M15 18a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1m-6 0a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-drizzle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudDrizzle;
